import React, { useEffect, useState } from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";
import Default from "../../../vendors/components/Layouts/Default";
import { BlockUI } from "primereact/blockui";
import { BlockUIState } from "../../../vendors/redux/@types/blockUI";
import { ProgressSpinner } from "primereact/progressspinner";
import BlockUIService from "../../../vendors/services/blockUIService";
import { menuItems } from "../../shared/config/menu";
import { MenuItem } from "../../../vendors/@types/menu";
import AuthService from "../../../vendors/services/authService";
import EmConstrucao from "../../../vendors/pages/Error/EmConstrucao";
import Portal from "../PublicPage/pages/Portal";
import EventoPage from "./Evento";
import MinhasContribuicoesPage from "./MinhasContribuicoes";
import MeusEventosPage from "./MeusEventos";
import PerfilPage from "./Perfil";
import EventoContribuicaoForm from "./Evento/pages/EventoContribuicaoForm";
import Evento from "../../../app/pages/PublicPage/pages/Evento";
import CompletarCadastro from "../PublicPage/pages/CompletarCadastro";
import InformesEvento from "../InformesEvento";
import EventoInterno from "../PublicPage/pages/EventoInterno";
import EventoInternoContribuicaoForm from "./Evento/pages/EventoInternoContribuicaoForm";
import ConsultarEventosPage from "./ConsultarEventos";
import FaleConoscoPage from "./FaleConosco";
import DuvidasFrequentes from "../DuvidasFrequentes";

const DefaultPage = () => {
  const blockUI: BlockUIState = new BlockUIService().getCurrentState();
  const [lista, setLista]: any = useState<any>([]);
  const history = useHistory();
  const location = useLocation();
  const authService = new AuthService();

  const isEventoRoute =
    location.pathname.startsWith("/evento/visualizar") ||
    location.pathname.startsWith("/evento/contribuicao") ||
    location.pathname.startsWith("/evento-interno") ||
    location.pathname.startsWith("/evento-interno-contribuicao") ||
    location.pathname.startsWith("/eventos");

  function filtraMenu(menu: MenuItem[]) {
    let novoMenu = [...menu];
    novoMenu = novoMenu.filter((f: MenuItem) => {
      if (!f.modulo) {
        return f;
      } else if (Array.isArray(f.modulo)) {
        const itemModulo = f.modulo.filter((m: any) => {
          if (authService.temPermissao(m)) {
            return m;
          }
        });
        if (itemModulo && itemModulo.length > 0) {
          return f;
        }
        return;
      } else {
        return authService.temPermissao(f.modulo);
      }
    });
    novoMenu = novoMenu.map((a) => ({
      ...a,
      items: a.items && filtraMenu(a.items),
    }));
    return novoMenu;
  }

  useEffect(() => {
    if (
      window.location.href.indexOf("login") < 0 &&
      !authService.isAuthenticated()
    ) {
      return history.push("/login");
    }
    authService.save(AuthService.getUser());
    setLista([...filtraMenu(menuItems)]);
  }, [location]);

  return (
    <>
      <BlockUI
        blocked={blockUI.blocked}
        template={
          <div className="flex flex-column align-items-center">
            <ProgressSpinner />
            <span style={{ color: "white", marginTop: "10px", fontWeight: "bold" }}>
              Carregando...
            </span>
          </div>
        }
        autoZIndex={true}
        baseZIndex={6000}
        fullScreen
      >
        <Switch>
          <Route path="/completar" exact={true} component={CompletarCadastro} />
          <Default menuItems={lista}>
            <Switch>
              <Route path="/home" component={Portal} />
              <Route path="/consultar-eventos" component={ConsultarEventosPage} />
              <Route path="/informes" exact={true} component={InformesEvento} />
              <Route
                path="/duvidas-frequentes"
                exact={true}
                component={DuvidasFrequentes}
              />
              <Route
                path="/minhas-contribuicoes"
                component={MinhasContribuicoesPage}
              />
              <Route path="/meus-eventos" component={MeusEventosPage} />
              <Route path="/fale-conosco" component={FaleConoscoPage} />
              <Route path="/evento" component={EventoPage} />
              <Route path="/perfil" component={PerfilPage} />
              <Route path="/em-construcao" component={EmConstrucao} />
              <Route path="/eventos" exact={true} component={Evento} />
              <Route path="/evento-interno" component={EventoInterno} />
              <Route
                path="/evento-interno-contribuicao"
                exact={true}
                component={EventoInternoContribuicaoForm}
              />
              {!isEventoRoute && <Redirect to="/perfil/inicio" />}
            </Switch>
          </Default>
        </Switch>
      </BlockUI>
    </>
  );
};

export default DefaultPage;
